import { useState, useEffect } from "react";

export const useRemoteData = (path, skip) => {
  const [data, setData] = useState(null);
  useEffect(() => {
    if (skip) return;
    fetch(`${process.env.REACT_APP_BACKEND_URL}/${path}`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    }).then(res => {
      if (!res.ok) return {"error": "Error fetching data"};
      return res.json()
    }).then(setData).catch(console.error);
  }, [path, skip]);
  return data;
}

export const useDocumentTitle = title => {
  useEffect(() => {
    document.title = title;
  }, [title]);
}